import { useTranslation } from 'react-i18next'

import { Box, Drawer, IconButton, List, ListItem, ListItemText, Stack, Typography } from '@mui/material'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import LoadingSwitch from '@/components/ui/switchs/LoadingSwitch'

type AssignLicenseDrawerProps = {
  licenses: Array<{
    id: string
    isAssigned?: boolean
    isAssigning?: boolean
    name: string
    availableQuantity?: number
  }>
  open: boolean
  onAssignLicense?: (licenseId: string, isAssigned: boolean) => void
  onClose?: () => void
  title: string
}

export default function AssignLicenseDrawer(props: AssignLicenseDrawerProps) {
  const { licenses, open, onAssignLicense, onClose, title } = props
  const { t } = useTranslation()

  return (
    <Drawer anchor="right" open={open} onClose={onClose} sx={{ zIndex: (theme) => theme.zIndex.drawer + 10 }}>
      <Stack direction="column" sx={{ height: '100%', minWidth: { xs: '360px', sm: '500px', md: '600px' }, p: '16px 32px' }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography component="h2" variant="h2">
            {title}
          </Typography>
          <IconButton onClick={onClose}>
            <CloseRoundedIcon />
          </IconButton>
        </Stack>
        <Box flex={1} py={3}>
          <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
            {licenses.map((license) => {
              return (
                <ListItem key={license.id} disablePadding data-testid={`license-row-${license.name}`}>
                  <ListItemText
                    primary={license.name}
                    secondary={
                      license.availableQuantity !== undefined
                        ? t('common:available', { count: license.availableQuantity, context: `${license.availableQuantity}` })
                        : undefined
                    }
                  />
                  <LoadingSwitch
                    disabled={license.availableQuantity === 0 && !license.isAssigned}
                    edge="end"
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      onAssignLicense?.(license.id, event.target.checked)
                    }}
                    checked={license.isAssigned}
                    loading={license.isAssigning}
                    data-testid={`license-toggle-${license.name}`}
                  />
                </ListItem>
              )
            })}
          </List>
        </Box>
      </Stack>
    </Drawer>
  )
}
